import React from 'react';

const ConditionalWrapper = ({ condition, wrapperIfTrue, wrapperIfFalse, children }) => 
    condition ? wrapperIfTrue(children) : wrapperIfFalse(children);

export default ConditionalWrapper;